























import {Component, Prop, Vue} from "vue-property-decorator";
import {PlayerState} from "@/app/minesweeper/enum";
import Lives from "@/components/Lives.vue";
import Player from "@/app/minesweeper/Player";

@Component({
    components: {Lives}
})
export default class PlayersDashboard extends Vue {
    @Prop() players!: Player[];
    @Prop() cellsToOpenCount!: number;
    @Prop() playerLivesCount!: number;
    PlayerState = PlayerState;
}
